import { triggerHapticFeedback } from '@otto-ec/apps-api/hapticfeedback';

export class AppsApi {

    initialize(): void {
        o_global.eventQBus.on('ft1.order-core.addToBasketResult', (result: {successful: boolean}) => {
            if (result.successful) {
                triggerHapticFeedback();
            }
        })
    }

}
